module.exports = __webpack_public_path__ + "img/47d595fa592640649cecb7dc00488ef9.b2202761.png";